const rellax = new Rellax('.js-rellax', 1.3);

/**
 * Function checks the width of the viewport
 * If the viewport is below 1200, disable parallax
 */
function checkWidth() {
  if (viewportWidth > 1200) {
    rellax.refresh();
  } else {
    if (rellax) {
      rellax.destroy();
    }
  }
}

setViewportWidth();
checkWidth();

window.addEventListener(
  'resize',
  function() {
    setViewportWidth();
    checkWidth();
  },
  false
);

// disable parallax animations for users who
// do not want animations
const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

if (mediaQuery.matches) {
  if (rellax) {
    rellax.destroy();
  }
}
